var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import TappingDropDown from "../../components/articleattributes/tappingdropdown.vue";
import ModalBase from "../../components/modalbase.vue";
import { isTappingChangeResult, } from "../articleattributes/tappingdropdown";
function createSvg(s) {
    const dp = new DOMParser();
    const svg = dp.parseFromString(s, "image/svg+xml").documentElement;
    return svg;
}
let TappingDialog = class TappingDialog extends Vue {
    constructor() {
        super(...arguments);
        this.appliedTapping = [];
    }
    close() { }
    submitForm() {
        return {
            laserSheetCuttingVertexKey: this.tapping.laserSheetCuttingVertexKey,
            candidates: this.tapping.candidates,
            selection: this.appliedTapping,
            svg: this.tapping.svg,
        };
    }
    submit() {
        this.submitForm();
        this.close();
    }
    onChange(result) {
        if (!isTappingChangeResult(result)) {
            throw Error("Wrong type.");
        }
        if (this.tapping.candidates[result.coreHoleId] !== undefined) {
            const candidateCenter = this.tapping.candidates[result.coreHoleId].center3;
            const selected = {
                center3: candidateCenter,
                screwThread: result.screwThread,
            };
            const selectedIndex = this.appliedTapping.findIndex(n => this.equalCenter3(n.center3, candidateCenter));
            if (selectedIndex !== -1 && result.screwThread.identifier === "0") {
                this.appliedTapping.splice(selectedIndex, 1);
            }
            else if (result.screwThread.identifier !== "0") {
                this.appliedTapping.push(selected);
            }
        }
    }
    equalCenter3(lhs, rhs) {
        for (let i = 0; i < lhs.entries.length; i++) {
            if (Math.abs(lhs.entries[i] - rhs.entries[i]) > 1) {
                return false;
            }
        }
        return true;
    }
    equalSelection(oldSelection, newSelection) {
        if (oldSelection.length !== newSelection.length) {
            return false;
        }
        let equal = true;
        oldSelection.forEach(oldSelected => {
            if (newSelection.find(newSelected => this.equalCenter3(oldSelected.center3, newSelected.center3) && oldSelected.screwThread === newSelected.screwThread) === undefined) {
                equal = false;
            }
        });
        return equal;
    }
    matchingScrewThreads(i) {
        return this.tapping.candidates[i].matchingScrewThreads;
    }
    defaultIndex(coreHoleId) {
        if (this.tapping === undefined) {
            return 0;
        }
        const selectedCenter = this.tapping.candidates[coreHoleId].center3;
        const appliedTappingEntry = this.appliedTapping.find(v => this.equalCenter3(v.center3, selectedCenter));
        if (appliedTappingEntry !== undefined) {
            const selectedScrewThreadIndex = this.tapping.candidates[coreHoleId].matchingScrewThreads.findIndex(s => s.identifier === appliedTappingEntry.screwThread.identifier);
            return selectedScrewThreadIndex + 1;
        }
        return 0;
    }
    get submittable() {
        return !this.equalSelection(this.tapping.selection, this.appliedTapping);
    }
    created() {
        this.appliedTapping = [...this.tapping.selection];
    }
    mounted() {
        if (this.tapping !== undefined) {
            this.currentSvg = createSvg(this.tapping.svg);
            const s = this.$el.querySelector(".tapping-svg");
            if (s === undefined || s === null) {
                throw Error("Selector '.tapping-svg' does not match");
            }
            s.appendChild(this.currentSvg);
        }
    }
};
__decorate([
    Prop({ required: true })
], TappingDialog.prototype, "tapping", void 0);
__decorate([
    Inject()
], TappingDialog.prototype, "i18n", void 0);
__decorate([
    Inject()
], TappingDialog.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], TappingDialog.prototype, "close", null);
__decorate([
    Emit()
], TappingDialog.prototype, "submitForm", null);
TappingDialog = __decorate([
    Component({
        components: {
            "modal-base": ModalBase,
            "tapping-drop-down": TappingDropDown,
        },
        name: "TappingDialog",
    })
], TappingDialog);
export default TappingDialog;
